const rankingItems = [
  { rank: 1, title: '星光深处的你', type: '韩漫·都市言情', update: '第87话', status: '今日更新', hot: true },
  { rank: 2, title: '深渊游戏', type: '日漫·悬疑推理', update: '第134话', status: '今日更新', hot: true },
  { rank: 3, title: '蔷薇之约', type: '韩漫·都市言情', update: '第二季第12话', status: '昨日更新', hot: false },
  { rank: 4, title: '我为天帝', type: '国漫·修仙玄幻', update: '第56话', status: '昨日更新', hot: false },
  { rank: 5, title: '暗夜追踪者', type: '日漫·推理长篇', update: '第203话', status: '2天前更新', hot: true },
  { rank: 6, title: '灵笼战纪', type: '国漫·科幻巨制', update: '第42话', status: '2天前更新', hot: false },
  { rank: 7, title: '甜蜜的谎言', type: '韩漫·浪漫喜剧', update: '番外篇', status: '3天前更新', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            追更榜单
          </h2>
          <p className="text-foreground-600 text-sm max-w-xl mx-auto">
            实时追踪最热连载漫画，人气排名一目了然
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={idx}
                href="#index"
                className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100 cursor-pointer ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-white'
                    : item.rank === 2
                    ? 'bg-primary-300 text-primary-900'
                    : item.rank === 3
                    ? 'bg-secondary-300 text-secondary-900'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-heading text-sm font-bold text-foreground-900">{item.title}</h3>
                    {item.hot && (
                      <span className="inline-block px-1.5 py-0.5 rounded text-[10px] font-bold bg-accent-100 text-accent-700 whitespace-nowrap">
                        HOT
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{item.type}</div>
                </div>
                <div className="text-right flex-shrink-0 hidden sm:block">
                  <div className="text-sm font-medium text-foreground-800">{item.update}</div>
                  <div className="text-xs text-foreground-500">{item.status}</div>
                </div>
                <div className="flex-shrink-0">
                  <i className="ri-arrow-right-s-line text-foreground-400"></i>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}